import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Personal Branding and Online Identity",
      
      nestedContent: [
        { id: 1, text: "•	What personal branding is and why it matters in the digital world.", dummyText: [] },
        { id: 2, text: "•	How to identify your unique value proposition (UVP).", dummyText: [] },
        { id: 3, text: "•	Defining your personal brand through your strengths, passions, and goals.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Building a Strong Online Identity",
      nestedContent: [
        { id: 1, text: "•	Setting up a professional online presence (LinkedIn, personal website, etc.).", dummyText: [] },
        { id: 2, text: "•	Consistency across platforms (visuals, messaging, tone).", dummyText: [] },
        { id: 3, text: "•	Creating a memorable online presence that reflects your professional persona.", dummyText: [] },
        
       
      ],
    },
    {
        id: 3,
        title: " Defining Your Online Voice",
        nestedContent: [
          { id: 1, text: "•	How to develop a clear and authentic voice online.", dummyText: [] },
          { id: 2, text: "•	Tailoring your voice to different platforms (LinkedIn vs. Twitter vs. personal blog).", dummyText: [] },
          { id: 3, text: "•	Aligning your online content with your personal values and goals.", dummyText: [] },
         
        
        ],
      },
      
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: "Choosing the Right Platforms",
      nestedContent: [
        { id: 1, text: "•	Analyzing which social media platforms are best for your goals (LinkedIn for professionals, Instagram for creatives, Twitter for thought leadership). ", dummyText: [] },
        { id: 2, text: "•	Tailoring content for each platform to maximize engagement.", dummyText: [] },
       
       
      ],
    },
    {
      id: 2,
      title: "  Content Creation and Curation",
      nestedContent: [
        { id: 1, text: "•	How to create and share valuable content that resonates with your target audience.", dummyText: [] },
        { id: 2, text: "•	Best practices for writing blog posts, articles, and social media updates.", dummyText: [] },
        { id: 3, text: "  •	Using multimedia (images, videos, infographics) to enhance your posts.", dummyText: [] },
       
      
      ],
    },
    {
        id: 3,
        title: " Growing and Engaging Your Audience",
        nestedContent: [
          { id: 1, text: "•	Building a community of followers through consistent content.", dummyText: [] },
          { id: 2, text: "•	Engaging with followers: responding to comments, starting conversations, and creating interactive content.", dummyText: [] },
          { id: 3, text: "•	Building relationships with influencers and thought leaders in your field.", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: "Setting Up a Personal Website",
      nestedContent: [
        { id: 1, text: "•	How to build a personal website or portfolio (using platforms like WordPress, Wix, or Squarespace).", dummyText: [] },
        { id: 2, text: "•	Best practices for creating an attractive, professional design.", dummyText: [] },
        { id: 3, text: "•	What pages to include: About Me, Portfolio, Blog, Contact Info.", dummyText: [] },
        
       
      ],
    },
    {
      id: 4,
      title: "Blogging and Content Marketing",
      nestedContent: [
        { id: 1, text: "•	Writing engaging blog posts that showcase your expertise.", dummyText: [] },
        { id: 2, text: "•	Using SEO (Search Engine Optimization) strategies to increase your blog’s visibility.", dummyText: [] },
        { id: 3, text: "•	Building an email list to nurture your audience and keep them engaged.", dummyText: [] },
       
        
      ],
    },
    {
        id: 5,
        title: " Web Analytics and Metrics",
        nestedContent: [
          { id: 1, text: "•	Understanding basic website analytics (Google Analytics, etc.) to track visitors, traffic sources, and user behavior.", dummyText: [] },
          { id: 2, text: "•	Measuring the effectiveness of your content strategy and adjusting as needed.", dummyText: [] },
        
          
        ],
      },
      
     
  ];
 
  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: " Monitoring Your Digital Footprint",
      nestedContent: [
        { id: 1, text: "•	How to regularly check and manage your online presence.", dummyText: [] },
        { id: 2, text: "•	Tools and resources to monitor what’s being said about you (Google Alerts, Mention).", dummyText: [] },
        { id: 3, text: "•	Strategies to clean up negative or inaccurate online content.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "2 Managing Reviews and Testimonials",
      nestedContent: [
        { id: 1, text: "•	How to request and display client or colleague testimonials on your digital profiles.", dummyText: [] },
        { id: 2, text: "•	Responding to online reviews and feedback professionally.", dummyText: [] },
        { id: 3, text: "•	Building a positive online reputation through consistent, quality work and interactions.", dummyText: [] },
       
      ],
    },
    {
        id: 7,
        title: "Crisis Management and Damage Control",
        nestedContent: [
          { id: 1, text: "•	How to handle online criticism or negative publicity.", dummyText: [] },
          { id: 2, text: "•	Steps to take if your online reputation is damaged.", dummyText: [] },
          { id: 3, text: "•	Developing a personal crisis management plan for your digital presence", dummyText: [] },
        
        ],
      },
      
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Leveraging LinkedIn for Networking",
      nestedContent: [
        { id: 1, text: "•		Optimizing your LinkedIn profile (headline, summary, recommendations).", dummyText: [] },
        { id: 2, text: "•	How to build a strong professional network and connect with industry leaders.", dummyText: [] },
        { id: 3, text: " •	Using LinkedIn for job searches, collaborations, and partnerships.", dummyText: [] },

       
      ],
    },
    {
      id: 8,
      title: " Joining Online Communities and Forums",
      nestedContent: [
        { id: 1, text: "•	Engaging with niche communities (Reddit, Quora, specialized forums).", dummyText: [] },
        { id: 2, text: "•	How to contribute to online discussions and establish authority.", dummyText: [] },
        { id: 3, text: "•	Building relationships with peers, mentors, and influencers through digital communities.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Virtual Collaboration Tools",
        nestedContent: [
          { id: 1, text: "•	How to effectively use virtual collaboration tools (Slack, Zoom, Google Drive).", dummyText: [] },
          { id: 2, text: "•	Best practices for remote networking and collaborating online.", dummyText: [] },
          { id: 3, text: "•	Managing relationships and maintaining communication in a virtual environment.", dummyText: [] },
        ],
      },
      
      
      
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "  Protecting Your Digital Identity",
      nestedContent: [
        { id: 1, text: "•	Understanding online security threats and how to protect your digital identity.", dummyText: [] },
        { id: 2, text: "•	Using strong passwords, two-factor authentication, and secure email practices.", dummyText: [] },
        { id: 3, text: " •	Recognizing and avoiding phishing scams and other online fraud.", dummyText: [] },
      ],
     
    },
    {
      id: 10,
      title: "Managing Privacy Settings",
      nestedContent: [
        { id: 1, text: "•	Adjusting privacy settings on social media and online platforms to control what is shared and who can see it.", dummyText: [] },
        { id: 2, text: "•	Understanding the importance of keeping personal and professional life separate online.", dummyText: [] },
       
      ],
     

    },
    {
      id: 11,
      title: "Ethical Considerations and Digital Etiquette",
      nestedContent: [
        { id: 1, text: "•	Understanding the importance of online ethics, respect, and professionalism.", dummyText: [] },
        { id: 2, text: "•	Being mindful of your digital footprint and how it can affect your career and personal life.", dummyText: [] },
        { id: 3, text: "•	Following best practices for maintaining professionalism across all online platforms.", dummyText: [] },
       
      ],
    },
    
  ];


  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'-49px', }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Comprehensive Digital Presence Skills Curriculum
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
     ESocial Media Strategy and Engagement
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
      Website and Blog Development
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
       Online Reputation Management
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
 Digital Networking and Collaboration
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
     Digital Security and Privacy
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
      
    </div>
  );
};

export default LearningPathTFD;




